import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './ui/App.js'
import { ErrorBoundary } from './ui/ErrorBoundary.js'
import './ui/styles/tokens.css'

const el = document.getElementById('root')
if (!el) throw new Error('#root nenalezen')

createRoot(el).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
)
